import { render } from "./ProfileDisplay.vue?vue&type=template&id=5edf7138"
import script from "./ProfileDisplay.vue?vue&type=script&lang=js"
export * from "./ProfileDisplay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Melissa\\Desktop\\lifehack\\lifehack\\lifehack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__